import React, { useEffect, useState } from 'react';

import Baloon from './baloon';

export default function Tooltip({
  text,
  topCoords,
  className,
  forceHidden,
  classNameBaloon,
  children,
}) {
  const [revealed, setRevealed] = useState(false);
  const [hidden, setHidden] = useState(forceHidden);
  useEffect(() => {
    if(forceHidden)  {
      setHidden(forceHidden);
      setRevealed(false);
    }
  }, [forceHidden]);

  const revealTooltip = () => {
    if (forceHidden) {
      return;
    }
    setHidden(false);
    setRevealed(true);
  };

  const hideTooltip = () => {
    setRevealed(false);
    setHidden(true);
  };

  return (
    <div 
      className={className}
      onMouseEnter={revealTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
      <Baloon
        text={text}
        classNameBaloon={classNameBaloon}
        topCoords={topCoords}
        revealed={revealed}
        hidden={hidden}
      />
    </div>
  );
}